import React from "react";

import styles from './files.module.scss';
import { KoText } from "packages/typography";
import KoIcon from '@kwapio/icons';
import KoImage from "packages/image";
import { formatFileSize } from "shared/utils";


function FileInfo(props) {
  const { data, row, onCellClick, colName, onExtraClick } = props;
  return (
    data && <div className={`profileChar ${styles.membersWrapper}`}>
      <div className={`${styles.circle} `}>
        {row?.type?.includes('image') && <KoImage width={20} height={20} src={row?.url} />}
        {row?.type?.includes('video') && <KoIcon width={20} height={20} name={'VideoFileOutlined'} />}
        {row?.type?.includes('audio') && <KoIcon width={20} height={20} name={'AudioFileOutlined'} />}
        {row?.type?.includes('pdf') && <KoIcon width={17} height={17} name={'PdfOutlined'} />}
        {row?.type?.includes('zip') && <KoIcon width={20} height={20} name={'ZipFilled'} />}
        {row?.type?.includes('xlsx') && <KoIcon width={20} height={20} name={'XLSFileOutlined'} />}
        {row?.type?.includes('docx') && <KoIcon width={20} height={20} name={'FileOutlined'} />}
        {row?.type?.includes('txt') && <KoIcon width={20} height={20} name={'FileOutlined'} />}
        {row?.type?.includes('csv') && <KoIcon width={20} height={20} name={'XLSFileOutlined'} />}
        {row?.type?.includes('ppt') && <KoIcon width={20} height={20} name={'PPTFileOutlined'} />}
        {row?.type?.includes('code') && <KoIcon width={20} height={20} name={'CodeOutlined'} />}
        {row?.type?.includes('json') && <KoIcon width={20} height={20} name={'CodeOutlined'} />}
        {row?.type?.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') &&
        <KoIcon width={20} height={20} name={'FileOutlined'} />}
      </div>
      <div className={styles.memberInfo}>
        <div className={`${row?.isStarred ? styles.starred : styles.nameWrapper}`} >
          <KoText text={`${data}`} className={`${styles.memberName}`} onClick={() => onCellClick && onCellClick(row, colName)}/>
          <KoIcon
            onClick={() => onExtraClick && onExtraClick(row, colName)}
            className={styles.icon}
            name={'StarOutlined'}
            width={14}
            color={row?.isStarred ? 'var(--query)' : ''}
            height={14}
          />
        </div>
        <div className={styles.emailWrapper}>
          {row?.size ? <KoText text={`${formatFileSize(row?.size)}`} className={styles.email} /> : ''}
          {row?.type && <KoText text={`${row?.type}`} className={styles.email} />}
          {row?.uid?.includes('DOC-') && <KoText text={`(Spec)`} className={styles.email} />}
        </div>
      </div>
    </div>
  );
}
export default FileInfo;
